import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import logo from "../assets/images/logo.png";
import pdfTupa from "../assets/docs/tupa2025.pdf";

import "./HeaderMain.css";

const HeaderMain = () => {
  const [isScrolled, setIsScrolled] = useState(false);

  
  const [openDropdown, setOpenDropdown] = useState(null);

  const handleDropdownToggle = (id) => {
    if (window.innerWidth >= 992) return;
    setOpenDropdown((prev) => (prev === id ? null : id));
  };

 
  const closeMobileMenu = () => {
    const menu = document.getElementById("mainNavbar");
    if (menu && window.innerWidth < 992) {
      menu.classList.remove("show");
    }
    setOpenDropdown(null);
  };

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const handleSmoothScroll = (sectionId) => {
    const currentPath = window.location.pathname;
    if (currentPath === "/") {
      const target = document.getElementById(sectionId);
      if (target) {
        window.scrollTo({
          top: target.offsetTop - 100,
          behavior: "smooth",
        });
      }
    } else {
      window.location.href = `/#${sectionId}`;
    }

   
    closeMobileMenu();
  };

  return (
    <header className={`header-main ${isScrolled ? "transparent" : ""}`}>
      <nav className="navbar navbar-expand-lg shadow-sm">
        <div className="container-fluid px-4">

          {/* Logo */}
          <Link className="navbar-brand d-flex align-items-center" to="/" onClick={closeMobileMenu}>
            <img src={logo} alt="Logo" className="main-logo me-2" />
            <span className="institute-name">IESTP Gilda Ballivián</span>
          </Link>

          {/* Botón móvil */}
          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#mainNavbar"
          >
            <span className="navbar-toggler-icon"></span>
          </button>

          {/* Menú */}
          <div className="collapse navbar-collapse justify-content-end" id="mainNavbar">
            <ul className="navbar-nav align-items-center">

            
              <li className="nav-item">
                <Link className="nav-link" to="/" onClick={closeMobileMenu}>
                  Inicio
                </Link>
              </li>

              {/* NOSOTROS */}
              <li className={`nav-item dropdown ${openDropdown === "nosotros" ? "show" : ""}`}>
                <a
                  className="nav-link dropdown-toggle"
                  href="#"
                  onClick={(e) => {
                    e.preventDefault();
                    handleDropdownToggle("nosotros");
                  }}
                >
                  Nosotros
                </a>

                <ul className={`dropdown-menu ${openDropdown === "nosotros" ? "show" : ""}`}>
                  <li><Link className="dropdown-item" to="/nosotros/presentacion" onClick={closeMobileMenu}>Presentacion</Link></li>
                  <li><Link className="dropdown-item" to="/nosotros/mision" onClick={closeMobileMenu}>Misión,Visión y Valores</Link></li>
                  <li><Link className="dropdown-item" to="/nosotros/organizacion" onClick={closeMobileMenu}>Organizacion Institucional</Link></li>

                  <li><hr className="dropdown-divider" /></li>

                  <li><Link className="dropdown-item" to="/nosotros/autoridades" onClick={closeMobileMenu}>Autoridades</Link></li>
                  <li><Link className="dropdown-item" to="/nosotros/planaDocente" onClick={closeMobileMenu}>Plana Docente</Link></li>
                  <li><Link className="dropdown-item" to="/nosotros/local" onClick={closeMobileMenu}>Local</Link></li>
                  <li><Link className="dropdown-item" to="/nosotros/director" onClick={closeMobileMenu}>El Director</Link></li>
                </ul>
              </li>

              {/* PROGRAMAS */}
              <li className={`nav-item dropdown ${openDropdown === "programas" ? "show" : ""}`}>
                <a
                  className="nav-link dropdown-toggle"
                  href="#"
                  onClick={(e) => {
                    e.preventDefault();
                    handleDropdownToggle("programas");
                  }}
                >
                  Programas de Estudios
                </a>

                <ul className={`dropdown-menu ${openDropdown === "programas" ? "show" : ""}`}>
                  <li><Link className="dropdown-item" to="/programas/construccion-civil" onClick={closeMobileMenu}>Construccion Civil</Link></li>
                  <li><Link className="dropdown-item" to="/programas/contabilidad" onClick={closeMobileMenu}>Contabilidad</Link></li>
                  <li><Link className="dropdown-item" to="/programas/desarrollo-de-sistemas-de-informacion" onClick={closeMobileMenu}>Desarrollo de Sistemas de Informacion</Link></li>
                  <li><Link className="dropdown-item" to="/programas/electricidad-industrial" onClick={closeMobileMenu}>Electricidad Industrial</Link></li>
                  <li><Link className="dropdown-item" to="/programas/electronica-industrial" onClick={closeMobileMenu}>Electronica Industrial</Link></li>
                  <li><Link className="dropdown-item" to="/programas/gestion-administrativa" onClick={closeMobileMenu}>Gestion Administrativa</Link></li>
                  <li><Link className="dropdown-item" to="/programas/mecanica-de-produccion-industrial" onClick={closeMobileMenu}>Mecanica de Produccion Industrial</Link></li>
                  <li><Link className="dropdown-item" to="/programas/mecatronica-automotriz" onClick={closeMobileMenu}>Mecatroninca Automotriz</Link></li>
                </ul>
              </li>

              {/* ADMISION */}
              <li className={`nav-item dropdown ${openDropdown === "admision" ? "show" : ""}`}>
                <a
                  className="nav-link dropdown-toggle"
                  href="#"
                  onClick={(e) => {
                    e.preventDefault();
                    handleDropdownToggle("admision");
                  }}
                >
                  Admision y Matrícula
                </a>

                <ul className={`dropdown-menu ${openDropdown === "admision" ? "show" : ""}`}>
                  <li><Link className="dropdown-item" to="/admision-matricula/admision" onClick={closeMobileMenu}>Admisión</Link></li>
                  <li><Link className="dropdown-item" to="/mision" onClick={closeMobileMenu}>Matrícula</Link></li>
                  <li><Link className="dropdown-item" to="/admision-matricula/becas" onClick={closeMobileMenu}>Becas y Credito</Link></li>
                </ul>
              </li>

              {/* TRANSPARENCIA */}
              <li className={`nav-item dropdown ${openDropdown === "transparencia" ? "show" : ""}`}>
                <a
                  className="nav-link dropdown-toggle"
                  href="#"
                  onClick={(e) => {
                    e.preventDefault();
                    handleDropdownToggle("transparencia");
                  }}
                >
                  Transparencia
                </a>

                <ul className={`dropdown-menu ${openDropdown === "transparencia" ? "show" : ""}`}>
                  <li><Link className="dropdown-item" to="/transparencia/doc_gestion" onClick={closeMobileMenu}>Documentos de Gestion</Link></li>
                  <li><Link className="dropdown-item" to="/mision" onClick={closeMobileMenu}>Estadisticas</Link></li>
                  <li><Link className="dropdown-item" to="/transparencia/inversiones" onClick={closeMobileMenu}>Inversiones y Recursos</Link></li>
                  <li><Link className="dropdown-item" to="/mision" onClick={closeMobileMenu}>Libro de reclamaciones</Link></li>
                  <li><Link className="dropdown-item" to="/transparencia/licenciamiento" onClick={closeMobileMenu}>Licenciamiento</Link></li>
                </ul>
              </li>

              {/* TRÁMITES */}
              <li className={`nav-item dropdown ${openDropdown === "tramites" ? "show" : ""}`}>
                <a
                  className="nav-link dropdown-toggle"
                  href="#"
                  onClick={(e) => {
                    e.preventDefault();
                    handleDropdownToggle("tramites");
                  }}
                >
                  Trámites
                </a>

                <ul className={`dropdown-menu ${openDropdown === "tramites" ? "show" : ""}`}>
                  <li>
                    <a className="dropdown-item" href={pdfTupa} target="_blank" rel="noopener noreferrer" onClick={closeMobileMenu}>
                      TUPA
                    </a>
                  </li>
                  <li><Link className="dropdown-item" to="/mision" onClick={closeMobileMenu}>Mesa de Partes</Link></li>
                  <li><Link className="dropdown-item" to="/organigrama" onClick={closeMobileMenu}>Estadísticas</Link></li>
                </ul>
              </li>

              {/* CONTACTO */}
              <li className="nav-item">
                <Link className="nav-link" to="/contactanos/contact" onClick={closeMobileMenu}>Contactanos</Link>
              </li>

              {/* SERVICIOS */}
              <li className={`nav-item dropdown ${openDropdown === "servicios" ? "show" : ""}`}>
                <a
                  className="nav-link dropdown-toggle"
                  href="#"
                  onClick={(e) => {
                    e.preventDefault();
                    handleDropdownToggle("servicios");
                  }}
                >
                  Servicios
                </a>

                <ul className={`dropdown-menu ${openDropdown === "servicios" ? "show" : ""}`}>
                  <li>
                    <a
                      className="dropdown-item"
                      href="https://www.digitaliapublishing.com/"
                      target="_blank"
                      rel="noopener noreferrer"
                      onClick={closeMobileMenu}
                    >
                      Biblioteca
                    </a>
                  </li>
                  <li><Link className="dropdown-item" to="/organigrama" onClick={closeMobileMenu}>Servicios Complementarios</Link></li>
                  <li><Link className="dropdown-item" to="/servicios/bolsa" onClick={closeMobileMenu}>Bolsa Laboral</Link></li>
                  <li><Link className="dropdown-item" to="/mision" onClick={closeMobileMenu}>Intranet</Link></li>
                  <li><Link className="dropdown-item" to="/organigrama" onClick={closeMobileMenu}>Aula Virtual</Link></li>
                  <li><Link className="dropdown-item" to="/organigrama" onClick={closeMobileMenu}>Bienestar y Empleabilidad</Link></li>
                </ul>
              </li>

              {/* OTRAS PÁGINAS */}
              <li className={`nav-item dropdown ${openDropdown === "otras" ? "show" : ""}`}>
                <a
                  className="nav-link dropdown-toggle"
                  href="#"
                  onClick={(e) => {
                    e.preventDefault();
                    handleDropdownToggle("otras");
                  }}
                >
                  Otras Paginas
                </a>

                <ul className={`dropdown-menu ${openDropdown === "otras" ? "show" : ""}`}>
                  <li><Link className="dropdown-item" to="/otrasPaginas/comunicados" onClick={closeMobileMenu}>Comunicados</Link></li>
                  <li><Link className="dropdown-item" to="/otrasPaginas/enlaces" onClick={closeMobileMenu}>links Institucionales</Link></li>

                  <li>
                    <a
                      className="dropdown-item"
                      href="/#eventos"
                      onClick={(e) => {
                        e.preventDefault();
                        handleSmoothScroll("eventos");
                        closeMobileMenu();
                      }}
                    >
                      Noticias y Eventos
                    </a>
                  </li>
                </ul>
              </li>

            </ul>
          </div>
        </div>
      </nav>
    </header>
  );
};

export default HeaderMain;
